import { createWorkLog } from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOGS } from "../queries/useQueryWorkLogs";
import { QUERY_WORK_LOGS_SUMMARY } from "../queries/useQueryWorkLogsSummary";

export const useMutationCreateWorkLog = () =>
  useWSMutation<
    Awaited<ReturnType<typeof createWorkLog>>,
    WSServiceError,
    Parameters<typeof createWorkLog>[0]
  >(requestData => createWorkLog(requestData), {
    dependencies: [QUERY_WORK_LOGS, QUERY_WORK_LOGS_SUMMARY]
  });
